import React from 'react';

const Footer = () => (
  <footer className="bg-blue-600 text-white py-10 px-4 text-center">
    <h3 className="text-xl font-semibold mb-4">Water Systems</h3>
    <p className="mb-2">Ambattur, Chennai, Tamilnadu, 600099</p>
    <p className="mb-4">Email: info@watersystems.com | Phone: +91 99520 06305</p>
    <p className="text-sm">&copy; {new Date().getFullYear()} Water Systems Solutions. All rights reserved.</p>
  </footer>
);

export default Footer;
